export enum ContactFormConversion {
  Sales = 'Contact - Contact Us'
}

export enum ContactFormType {
  General = 'general',
  Support = 'technical'
}